import random from "./random";

export default {
	generate(length: number, chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"): string {
		if (!Number.isInteger(length)) {
			throw new Error(`length: ${length} is not an integer`);
		}
		return `YV_${new Array(length)
			.fill(null)
			.map((_) => random.item(chars))
			.join("")}`;
	},
	generateKey(instituteId: number, courseId: string, quizId: string) {
		const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
		const randomString = new Array(12)
			.fill(null)
			.map((_) => random.item(chars))
			.join("");
		const key = `${instituteId}_${courseId}_${quizId}_${randomString}`;
		return `VP_${btoa(key)}`.replace(/=/g, "").slice(0, 20);
	},
};
